import { Scale } from 'app/components/uikit/lex-horizontal-stepper/lex-horizontal-stepper.component';
import { Constants } from 'app/constants/constants';
import { Decimals, MetricSettings, StepValue } from './widget-predictive.component';

export const decimalsToPipeDigitInfo = (decimals: Decimals): string => `1.${decimals}-${decimals}`;

export const createStepperScale = (metricSettings: MetricSettings, stepValue: StepValue): Scale => {
  let min: number;
  let max: number;

  switch (metricSettings.scoring) {
    default:
    case 'AVERAGE':
      min = +metricSettings.min;
      max = metricSettings.max;
      break;
    case 'BOX':
      min = Constants.BOX_MIN;
      max = Constants.BOX_MAX;
      break;
    case 'NPS':
      min = Constants.NPS_MIN;
      max = Constants.NPS_MAX;
      break;
  }

  const stepPercent = getStepPercentFromStepValue(stepValue);

  return {
    min,
    max,
    step: max * stepPercent,
  };
};

export const getStepPercentFromStepValue = (stepValue: StepValue): number => {
  switch (stepValue) {
    case '1%':
      return 0.01;
    case '5%':
      return 0.05;
    default:
    case '10%':
      return 0.1;
  }
};

export const createRangeFromMetricSettings = (metricSettings: MetricSettings): string => {
  return `${metricSettings.min}:${metricSettings.max}`;
};
